import apiClient from "@/shared/api/apiClient2";

export const updateApplicationStatus = async (tx_id, params) => {
  const { data } = await apiClient.put(`/applications/${tx_id}/status`, {
    ...params,
  });
  return data;
};

export const updateApplicationNote = async (tx_id, note) => {
  const { data } = await apiClient.put(`/applications/${tx_id}/note`, { note });
  return data;
};

export const createNotaryActionFromApplication = async (
  tx_id,
  { target_status, notary_action_code } = {}
) => {
  const { data } = await apiClient.post(
    `/applications/${tx_id}/create-notary-action`,
    {
      target_status,
      ...(notary_action_code ? { notary_action_code } : {}),
    }
  );
  return data;
};
